<template>
  <v-row dense align="end" class="fill-height">
    <v-col :class="[readOnly ? 'pt-3' : '']">
      <v-text-field
        v-model="internal_value"
        :label="field.label"
        placeholder=" "
        :disabled="readOnly || disabled"
        :outlined="!readOnly"
        dense
        hide-details
        pattern="^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$"
        type="time"
        @focus="handleFocus"
        @click="handleFocus"
        :background-color="readOnly ? '' : 'white'"
      />
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: "InputText",
    props: {
      field: Object,
      value: String,
      readOnly: Boolean,
      disabled: Boolean,
    },
    model: {
      prop: "value",
      event: "change",
    },
    computed: {
      internal_value: {
        set(value) {
          this.$emit("change", value);
        },
        get() {
          return this.value;
        },
      },
    },
    methods: {
      handleFocus() {
        if (this.internal_value === "") {
          this.internal_value = this.$moment().format("HH:mm");
        }
      },
    },
  };
</script>

<style lang="scss" scoped></style>
